import React from 'react';
import { useTranslation } from 'react-i18next';

import WorkOffIcon from '@/assets/images/icons/work-off.svg';

import ErrorPage from '../ErrorPage';

const AccessDenied = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage
      logo={<WorkOffIcon />}
      title={t('components.AccessDenied.title')}
      linkHref="/admin"
      linkText={t('components.AccessDenied.linkText')}
    >
      {t('components.AccessDenied.textRestrict')}
      <br />
      {t('components.AccessDenied.textRequest')}
    </ErrorPage>
  );
};

export default AccessDenied;
